import { rootApi } from '../rootApi';

/**
 * LMS Ön Koşul Tanımları — `/v1.0/LmsPrecondition`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §6.
 *
 * Tanım anahtarı `code`'dur; kod backend tarafından üretilir, istekte hiç gönderilmez ve
 * güncellenemez. Her tanım 6 dilin tamamı için ayrı bir satır tutar (`translations` dizisi),
 * her satırda `precondition` (zorunlu) ve `description` (opsiyonel) alanları vardır.
 */
export const lmsPreconditionApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsPreconditions: builder.query({
            query: ({ code, text, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsPrecondition/GetList',
                method: 'POST',
                body: {
                    code: code || null,
                    text: text || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsPrecondition']
        }),

        getLmsPreconditionById: builder.query({
            query: (id) => ({
                url: 'v1/LmsPrecondition/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsPrecondition']
        }),

        addLmsPrecondition: builder.mutation({
            query: ({ translations }) => ({
                url: 'v1/LmsPrecondition/Add',
                method: 'POST',
                body: { translations }
            }),
            invalidatesTags: ['LmsPrecondition']
        }),

        updateLmsPrecondition: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsPrecondition/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsPrecondition']
        }),

        deleteLmsPrecondition: builder.mutation({
            query: (id) => ({
                url: `v1/LmsPrecondition/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsPrecondition']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsPreconditionsQuery,
    useGetLmsPreconditionByIdQuery,
    useAddLmsPreconditionMutation,
    useUpdateLmsPreconditionMutation,
    useDeleteLmsPreconditionMutation
} = lmsPreconditionApi;
